(() => {
  const roots = new WeakSet();

  function init(root) {
    if (!root || roots.has(root)) return;
    roots.add(root);

    root.querySelectorAll('[data-dw-v5-scroll]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const selector = link.getAttribute('href');
        if (!selector || !selector.startsWith('#')) return;
        const target = document.querySelector(selector);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    });

    const modal = root.querySelector('[data-dw-v5-modal]');
    const modalContent = root.querySelector('[data-dw-v5-modal-content]');
    const close = root.querySelector('[data-dw-v5-modal-close]');
    let opener;

    const closeModal = () => {
      if (!modal) return;
      modal.querySelector('video')?.pause();
      modal.hidden = true;
      modalContent.replaceChildren();
      opener?.focus();
    };

    root.querySelectorAll('[data-dw-v5-video-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const template = root.querySelector(`#${CSS.escape(trigger.dataset.videoId)}`);
        if (!template || !modal || !modalContent) return;
        opener = trigger;
        modalContent.replaceChildren(template.content.cloneNode(true));
        modal.hidden = false;
        close?.focus();
        modalContent.querySelector('video')?.play().catch(() => {});
      });
    });

    close?.addEventListener('click', closeModal);
    modal?.addEventListener('click', (event) => { if (event.target === modal) closeModal(); });
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
      if (event.key !== 'Tab' || !modal || modal.hidden) return;
      const focusable = modal.querySelectorAll('button,[href],video,[tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }

  function scan(scope = document) { scope.querySelectorAll('[data-dw-v5-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
